import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { ErrorList } from '../../../../shared-components/controls/error-prompt/error-list.model';
import { MyReportsFolder } from '../../reporting-framework.model';
import { ReportingFrameworkService } from '../../reporting-framework.service';

@Component({
  selector: 'add-my-report-folder-dialog',
  templateUrl: './add-my-report-folder-dialog.component.html',
  styleUrls: ['./add-my-report-folder-dialog.component.css']
})
export class AddMyReportFolderDialogComponent implements OnInit {

  dialogTitle: string;
  editMode: boolean;
  myReportFolder: MyReportsFolder;
  errorLists: ErrorList[] = [];
  saveAndNew = false;

  @ViewChild('folderNameRef', { read: ElementRef, static: true }) folderNameRef: ElementRef;
  constructor(
    private dialogRef: MatDialogRef<AddMyReportFolderDialogComponent>,
    private reportingFrameworkService: ReportingFrameworkService
  ) { }


  ngOnInit() {
    if (this.editMode == false) {
      this.myReportFolder.Id = 0;
    }
  }

  saveClick() {
    this.errorLists = [];
    if (this.myReportFolder.FolderName == undefined || this.myReportFolder.FolderName.trim() == '') {
      this.errorLists.push({
        fieldName: 'Folder Name',
        fieldRef: this.folderNameRef,
        errorMsg: ' is Required.'
      });
    }

    if (this.errorLists.length == 0) {
      this.saveAndNew = false;
      this.saveReportFolder();
    }
  }

  saveReportFolder() {
    this.reportingFrameworkService.saveMyReportFolder(this.myReportFolder).subscribe(result => {
      if (result == true) {
        if (this.saveAndNew == false) {
          this.dialogRef.close('save');
        } else {
          this.myReportFolder = new MyReportsFolder();
          this.myReportFolder.Id = 0;
        }
      }
    });
  }

  saveAndNewClick() {
    this.errorLists = [];
    if (this.myReportFolder.FolderName == undefined || this.myReportFolder.FolderName.trim() == '') {
      this.errorLists.push({
        fieldName: 'Folder Name',
        fieldRef: this.folderNameRef,
        errorMsg: ' is Required.'
      });
    }

    if (this.errorLists.length == 0) {
      this.saveAndNew = true;
      this.saveReportFolder();
    }
  }

  cancelClick() {
    if (this.saveAndNew == true) {
      this.dialogRef.close('save');
    } else {
      this.dialogRef.close('cancel');
    }
  }

}
